import React from 'react';
import styles from './AdminFooter.module.scss';

const AdminFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.adminFooter}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <div className={styles.footerLogo}>
            <h3>Econsiste</h3>
            <p>Soluções em Tecnologia</p>
          </div>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Links Rápidos</h4>
          <ul>
            <li><a href="/admin">Dashboard</a></li>
            <li><a href="/admin/easymove">Downloads</a></li>
            <li><a href="/">Site Principal</a></li>
          </ul>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Suporte</h4>
          <ul>
            <li><a href="mailto:suporte@econsiste.com">suporte@econsiste.com</a></li>
            <li><a href="tel:+5511999999999">+55 (34) 99762-8585</a></li>
          </ul>
        </div>
        
        <div className={styles.footerSection}>
          <h4>Informações</h4>
          <p>Painel Administrativo</p>
          <p>Versão 1.0</p>
        </div>
      </div>
      
      <div className={styles.footerBottom}>
        <div className={styles.footerBottomContent}>
          <p>&copy; {currentYear} Econsiste. Todos os direitos reservados.</p>
          <div className={styles.footerBottomLinks}>
            <a href="/privacy">Privacidade</a>
            <a href="/terms">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AdminFooter;
